<template>
  <router-view></router-view>
</template>

<script>
// import Game from './components/Game.vue'

export default {
  name: "App",
  components: {
    // Game
  },
};
</script>

<style>
:root {
  --barq-orange: #ff7c21;
  --barq-green: #128d15;
  --barq-darkblue: #68a2da;
  --barq-lightblue: #c5d7e8;
}

#app {
  /* background-color: #f2f2f2; */
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0px;
  padding: 0px;
  left: 0px;
  top: 0px;
}
@font-face {
  font-family: Arial-Rounded;
  src: url(../public/arlrdbd.ttf);
}
@font-face {
  font-family: Calibri-Bold;
  src: url(../public/Calibri_Bold.ttf);
}
@font-face {
  font-family: Calibri;
  src: url(../public/Calibri.ttf);
}

* {
  font-family: Arial-Rounded;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.pointer:hover {
  cursor: pointer;
}
</style>
